import dayjs from "dayjs";

export const hoursToDay = (hours: number) => {
  if (hours > 24) {
    const days = Math.floor(hours / 24);
    return days + (days > 1 ? " days" : " day");
  }
  return hours + (hours > 1 ? " hours" : " hour");
};

export const convertBirthdateToUtc = (birthdate: string, timezone: string) => {
  const [month, date, year] = birthdate.split("/");
  const timezonedBirthdateUTC = dayjs
    .tz(`${year}-${month}-${date}`, timezone)
    .utc();

  return timezonedBirthdateUTC;
};
